"use strict"
exports.__esModule = true;
exports.ImagesIconConfig = {
  name: 'ImagesIcon',
  height: 512,
  width: 576,
  svgPath: 'M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z',
  yOffset: 0,
  xOffset: 0,
};
exports.ImagesIcon = require('../createIcon').createIcon(exports.ImagesIconConfig);
exports["default"] = exports.ImagesIcon;